import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=158442a2&scoped=true&"
import script from "./deal.vue?vue&type=script&lang=js&"
export * from "./deal.vue?vue&type=script&lang=js&"
import style0 from "./deal.vue?vue&type=style&index=0&id=158442a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158442a2",
  null
  
)

export default component.exports